<template>
    <div class="container-fluid mb-2 mb-md-3">
        <div class="row">
            <div class="col-12">
                <div class="bg-greige d-flex p-1 align-items-center">
                    <!-- Une offre internet + un forfait = jusqu’à 180€/an d’économies -->
                    <span
                        class="icon icon-phone-fund-euro text-primary font-size-30 px-2"
                        aria-hidden="true"
                    />
                    <p class="h4 mb-0 mw-100 mobile-text-center">
                        <span class="offer-text" v-html="onBoardingOfferDescriptionText" />
                        <span class="break-text" v-html="onBoardingYearlyDiscountsInfoText" />
                    </p>
                    <button
                        class="btn btn-secondary ms-auto flex-shrink-0 d-flex justify-content-center align-items-center ms-2 me-2 w-200 mobile-max-width"
                        data-bs-toggle="modal"
                        :data-bs-target="'#' + discountAdvantagesPopin.id"
                        data-oevent-category="ouverture_popin"
                        data-oevent-action="en_savoir_plus"
                        data-oevent-label="avantages_remise_popin"
                    >
                        {{ buttonLabel }}
                    </button>
                </div>

                <discount-advantages-popin :dto-from-object="discountAdvantagesPopin" />
            </div>
        </div>
    </div>
</template>

<script>
import DiscountAdvantagesPopin from "../../../../../../common/advantages/DiscountAdvantagesPopin.vue";

export default {
    name: "InternetAndMobileOnBoarding",
  components: {DiscountAdvantagesPopin},
    props: {
        onBoardingOfferDescriptionText: {
            type: String,
            required: true
        },
        onBoardingYearlyDiscountsInfoText: {
            type: String,
            required: true
        },
        buttonLabel: {
            type: String,
            required: true
        },
        discountAdvantagesPopin: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
        }
    },
    computed: {
    }
}
</script>

<style scoped lang="scss">
@media (max-width: 767px) {
    .bg-greige {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .mobile-text-center {
        text-align: center;
    }
    .mobile-max-width {
        width: 100%;
        max-width: 100%;
        margin-top: 5px;
    }
}

@media (max-width: 1400px) {
    .break-text {
        display: block;
    }
}
</style>
